<template>
  <div class="container">
    <section class="section">
      <h1 class="title">Priorizacion</h1>
      <hr />
      <div class="buttons">
        <button
          @click="selectTitulo(k)"
          class="button is-small is-light"
          :class="clasebutton(k)"
          v-for="(k,v) in riesgos.numeros"
          :key="v"
        >{{traetitulo(k)}}</button>
        <button
          class="button is-small is-light"
          :class="clasebutton('todos')"
          @click="selectTitulo('todos')"
        >Todos</button>
      </div>
      <h1 class="title is-5">Priorizaciones</h1>
      <div class="columns is-multiline">
        <div class="column is-6">
          <y-graph :datagraph="datafactores" :cambio="cambio1"></y-graph>
        </div>
        <div class="column is-3" v-show="datafrstrans.clasificados.pa.length > 0">
          <div class="notification is-primary">
            <h1 class="title">Alta</h1>
            <h1 class="subtitle is-6">
              <strong
                class="has-text-white"
              >El 25% o mas de las personas se encuentra en el riesgo alto o muy alto.</strong>
              <br />Esta condición tiene alta probabilidad de asociarse con efectos desfavorables y por esta razon debe intervenirse en el corto plazo.
            </h1>
          </div>
        </div>
        <div
          class="column is-3"
          v-for="(riesgo, index) in datafrstrans.clasificados.pa"
          :key="index"
        >
          <div class="notification">
            <strong class="is-capitalized">{{nombreriesgo(riesgo.nombre)}}</strong>
            <y-minigraph
              :datagraph="datafrstrans[riesgo.nombre].dataGrafica"
              :cambio="datafrstrans[riesgo.nombre].cambio"
            ></y-minigraph>
            <span
              style="font-size: 30px;"
            >{{datafrstrans[riesgo.nombre].porcentclasif | number(2)}}%</span>
            <span>Personas: {{datafrstrans[riesgo.nombre].nclasif | number()}}</span>

            <div class="control">
              <label class="radio is-primary">
                <input
                  v-model="datafrstrans[riesgo.nombre].typeGraphic"
                  value="pie"
                  type="radio"
                  :name="index"
                  @click="cambio(datafrstrans[riesgo.nombre],'pa','pie')"
                />
              </label>
              <label class="radio">
                <input
                  v-model="datafrstrans[riesgo.nombre].typeGraphic"
                  value="bar"
                  type="radio"
                  :name="index"
                  @click="cambio(datafrstrans[riesgo.nombre],'pa','bar')"
                />
              </label>
              <label class="radio">
                <input
                  v-model="datafrstrans[riesgo.nombre].typeGraphic"
                  value="polarArea"
                  type="radio"
                  :name="index"
                  @click="cambio(datafrstrans[riesgo.nombre],'pa','polarArea')"
                />
              </label>
            </div>
          </div>
        </div>
        <div class="column is-3" v-show="datafrstrans.clasificados.ad.length > 0">
          <div class="notification is-info">
            <h1 class="title">Aspecto destacado</h1>
            <h1 class="subtitle is-6">
              <strong
                class="has-text-white"
              >Cuando el 60% de las personas se ubica en Factor Protector (cuando aplique), Sin riesgo o Riesgo despreciable o Riesgo bajo.</strong>
              <br />Este resultado puede considerarse favorable y se debe buscar que se mantenga.
            </h1>
          </div>
        </div>
        <div
          class="column is-3"
          v-for="(riesgo, index) in datafrstrans.clasificados.ad"
          :key="index+'k'"
        >
          <div class="notification">
            <strong class="is-capitalized">{{nombreriesgo(riesgo.nombre)}}</strong>
            <y-minigraph
              :datagraph="datafrstrans[riesgo.nombre].dataGrafica"
              :cambio="datafrstrans[riesgo.nombre].cambio"
            ></y-minigraph>
            <span
              style="font-size: 30px;"
            >{{datafrstrans[riesgo.nombre].porcentclasif | number(2)}}%</span>
            Personas: {{datafrstrans[riesgo.nombre].nclasif | number()}}
            <div class="control">
              <label class="radio is-primary">
                <input
                  v-model="datafrstrans[riesgo.nombre].typeGraphic"
                  value="pie"
                  type="radio"
                  :name="index+'k'"
                  @click="cambio(datafrstrans[riesgo.nombre],'ad','pie')"
                />
              </label>
              <label class="radio">
                <input
                  v-model="datafrstrans[riesgo.nombre].typeGraphic"
                  value="bar"
                  type="radio"
                  :name="index+'k'"
                  @click="cambio(datafrstrans[riesgo.nombre],'ad','bar')"
                />
              </label>
              <label class="radio">
                <input
                  v-model="datafrstrans[riesgo.nombre].typeGraphic"
                  value="polarArea"
                  type="radio"
                  :name="index+'k'"
                  @click="cambio(datafrstrans[riesgo.nombre],'ad','polarArea')"
                />
              </label>
            </div>
          </div>
        </div>
        <div class="column is-6" v-show="datafrstrans.clasificados.pm.length > 0">
          <div class="notification prioridadmedia">
            <h1 class="title">Prioridad Media</h1>
            <h1 class="subtitle is-6">
              <strong>La suma entre riesgo medio, riesgo alto y muy alto es igual o mayor al 40% de las personas.</strong>
              <br />Aqui la intervención es relevante, pues si la condición no se mejora en el corto/mediano plazo, puede asociarse con desenlace desfavorables para los trabajdores y la organización, incluso existe alta probabilidad que en un apróxima medición se convierta en una prioridad alta de intervención.
            </h1>
          </div>
        </div>
        <div
          class="column is-3"
          v-for="(riesgo, index) in datafrstrans.clasificados.pm"
          :key="index+'pm'"
        >
          <div class="notification">
            <strong class="is-capitalized">{{nombreriesgo(riesgo.nombre)}}</strong>
            <y-minigraph
              :datagraph="datafrstrans[riesgo.nombre].dataGrafica"
              :cambio="datafrstrans[riesgo.nombre].cambio"
            ></y-minigraph>
            <span
              style="font-size: 30px;"
            >{{datafrstrans[riesgo.nombre].porcentclasif | number(2)}}%</span>
            Personas: {{datafrstrans[riesgo.nombre].nclasif | number()}}
            <div class="control">
              <label class="radio is-primary">
                <input
                  v-model="datafrstrans[riesgo.nombre].typeGraphic"
                  value="pie"
                  type="radio"
                  :name="index+'pm'"
                  @click="cambio(datafrstrans[riesgo.nombre],'pm','pie')"
                />
              </label>
              <label class="radio">
                <input
                  v-model="datafrstrans[riesgo.nombre].typeGraphic"
                  value="bar"
                  type="radio"
                  :name="index+'pm'"
                  @click="cambio(datafrstrans[riesgo.nombre],'pm','bar')"
                />
              </label>
              <label class="radio">
                <input
                  v-model="datafrstrans[riesgo.nombre].typeGraphic"
                  value="polarArea"
                  type="radio"
                  :name="index+'pm'"
                  @click="cambio(datafrstrans[riesgo.nombre],'pm','polarArea')"
                />
              </label>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import yGraph from "@/components/dashboard/Graphpriorizacion.vue";
import apiServices from "@/services/yungol-services";
import yMinigraph from "@/components/dashboard/MiniGraph.vue";
export default {
  data() {
    return {
      cambio1: 0,
      datafactores: null,
      buttonselected: "01",
      riesgos: {
        numeros: [],
      },
      datafrs: {},
      datafrstrans: {
        listrgo: [],
        clasificados: {
          list: ["ad", "pm", "pa", "na"],
          ad: [],
          pm: [],
          pa: [],
          na: [],
        },
      },
      keysresultado: [],
      definiciones: {
        "Riesgo bajo": "2",
        "Riesgo alto": "4",
        "Riesgo medio": "3",
        "Sin riesgo o riesgo despreciable": "1",
        "Riesgo muy alto": "5",
        "Sin riesgo o riesgo bajo": "1",
        "Factor protector": "1",
        "Satisfacción muy alta": "1",
        "Satisfacción alta": "2",
        "Satisfacción baja": "3",
        "Insatisfacción muy alta": "5",
        "Insatisfacción alta": "4",
        "Presentación muy baja de síntomas o sin presencia de ellos": "2",
        "Presentación alta de síntomas": "4",
        "Presentación media de síntomas": "3",
        "Presentación muy alta de síntomas": "5",
        Bajo: "2",
        "Muy alto": "5",
        Alto: "4",
        "Muy bajo": "1",
        Medio: "3",
        "Caso no crítico": "2",
        "Caso muy crítico": "5",
        "Caso medianamente crítico": "3",
        "Caso crítico": "4",
      },
    };
  },
  methods: {
    creaFactores(frp, typeGraphic) {
      const _this = this;
      let typeGraphic1;
      let series;
      if (typeGraphic) {
        typeGraphic1 = typeGraphic;
      } else {
        typeGraphic1 = "bar";
      }
      let arraydata = [];
      _this.riesgos[frp].original.forEach(function (k) {
        arraydata.push(_this.datafrs.data[k]);
      });

      const colors = ["#38cbcd", "#6ce4e5", "#ffd36e", "#ff7e67", "#ce6757"];
      const listseries = {
        default: {
          enum: {
            "Sin riesgo o riesgo despreciable": 0,
            "Riesgo bajo": 1,
            "Riesgo medio": 2,
            "Riesgo alto": 3,
            "Riesgo muy alto": 4,
          },
          lista: [
            "Sin riesgo o riesgo despreciable",
            "Riesgo bajo",
            "Riesgo medio",
            "Riesgo alto",
            "Riesgo muy alto",
          ],
        },
        default1: {
          enum: {
            "Sin riesgo o riesgo bajo": 0,
            "Riesgo bajo": 1,
            "Riesgo medio": 2,
            "Riesgo alto": 3,
            "Riesgo muy alto": 4,
          },
          lista: [
            "Sin riesgo o riesgo bajo",
            "Riesgo bajo",
            "Riesgo medio",
            "Riesgo alto",
            "Riesgo muy alto",
          ],
        },
        frecuente: {
          enum: {
            "Poco frecuente": 0,
            "Medianamente frecuente": 1,
            Frecuente: 2,
            "Muy frecuente": 3,
            ".": 4,
          },
          lista: [
            "Poco frecuente",
            "Medianamente frecuente",
            "Frecuente",
            "Muy frecuente",
            ".",
          ],
        },
        satisfaccion: {
          enum: {
            "Satisfacción muy alta": 0,
            "Satisfacción alta": 1,
            "Satisfacción baja": 2,
            "Insatisfacción alta": 3,
            "Insatisfacción muy alta": 4,
          },
          lista: [
            "Satisfacción muy alta",
            "Satisfacción alta",
            "Satisfacción baja",
            "Insatisfacción alta",
            "Insatisfacción muy alta",
          ],
        },
        burnout: {
          enum: {
            "Presentación muy baja de síntomas o sin presencia de ellos": 0,
            ".": 1,
            "Presentación media de síntomas": 2,
            "Presentación alta de síntomas": 3,
            "Presentación muy alta de síntomas": 4,
          },
          lista: [
            "Presentación muy baja de síntomas o sin presencia de ellos",
            ".",
            "Presentación media de síntomas",
            "Presentación alta de síntomas",
            "Presentación muy alta de síntomas",
          ],
        },
        critico: {
          enum: {
            "Caso no crítico": 0,
            ".": 1,
            "Caso medianamente crítico": 2,
            "Caso crítico": 3,
            "Caso muy crítico": 4,
          },
          lista: [
            "Caso no crítico",
            ".",
            "Caso medianamente crítico",
            "Caso crítico",
            "Caso muy crítico",
          ],
        },
        protector: {
          enum: {
            "Factor protector": 0,
            "Sin riesgo o riesgo bajo": 1,
            "Riesgo medio": 2,
            "Riesgo alto": 3,
            "Riesgo muy alto": 4,
          },
          lista: [
            "Factor protector",
            "Sin riesgo o riesgo bajo",
            "Riesgo medio",
            "Riesgo alto",
            "Riesgo muy alto",
          ],
        },
        estres: {
          enum: {
            "Muy bajo": 0,
            Bajo: 1,
            Medio: 2,
            Alto: 3,
            "Muy alto": 4,
          },
          lista: ["Muy bajo", "Bajo", "Medio", "Alto", "Muy alto"],
        },
      };
      const seriescontrol = [];
      const data = {
        data: [[], [], [], [], []],
        data1: [[], [], [], [], []],
        labels: [],
        series: [
          "Sin riesgo o riesgo despreciable",
          "Riesgo bajo",
          "Riesgo medio",
          "Riesgo alto",
          "Riesgo muy alto",
        ],
        colors: colors,
        datasetOverride: [],
        options: {
          legend: {
            display: false,
            position: "bottom",
          },
          scales: {
            xAxes: [
              {
                stacked: true,
                ticks: {
                  beginAtZero: true,
                  max: 100,
                  steps: 10,
                },
              },
            ],
            yAxes: [
              {
                stacked: true,
                ticks: {
                  beginAtZero: true,
                  max: 100,
                  steps: 10,
                },
              },
            ],
          },
        },
        typeGraphic: typeGraphic1,
      };
      let totales = {};
      arraydata.forEach(function (k, v) {
        totales[k[0].Grupo] = 0;
        data.labels.push(k[0].Grupo.substr(7, k[0].Grupo.length));
        data.data1[0].push(0);
        data.data1[1].push(0);
        data.data1[2].push(0);
        data.data1[3].push(0);
        data.data1[4].push(0);
        data.data[0].push(0);
        data.data[1].push(0);
        data.data[2].push(0);
        data.data[3].push(0);
        data.data[4].push(0);
        k.forEach(function (k1, v1) {
          if (k1.SubGrupo) {
            totales[k[0].Grupo] += k1.countData.sum;
            if (seriescontrol.indexOf(k1.SubGrupo) === -1) {
              seriescontrol.push(k1.SubGrupo);
            }
          }
        });
      });
      let controldefault = 0;
      let controlfrecuente = 0;
      let controlsatisfaccion = 0;
      let controlburnout = 0;
      let controlcritico = 0;
      let controlprotector = 0;
      let controldefault1 = 0;
      let controlestres = 0;

      seriescontrol.forEach(function (k) {
        if (k) {
          if (listseries.default.lista.indexOf(k) === -1) {
            controldefault = 1;
          }
          if (listseries.frecuente.lista.indexOf(k) === -1) {
            controlfrecuente = 1;
          }
          if (listseries.satisfaccion.lista.indexOf(k) === -1) {
            controlsatisfaccion = 1;
          }
          if (listseries.burnout.lista.indexOf(k) === -1) {
            controlburnout = 1;
          }
          if (listseries.critico.lista.indexOf(k) === -1) {
            controlcritico = 1;
          }
          if (listseries.protector.lista.indexOf(k) === -1) {
            controlprotector = 1;
          }
          if (listseries.default1.lista.indexOf(k) === -1) {
            controldefault1 = 1;
          }
          if (listseries.estres.lista.indexOf(k) === -1) {
            controlestres = 1;
          }
        }
      });

      if (controldefault === 0) {
        series = listseries.default.enum;
        data.series = listseries.default.lista;
      } else if (controlfrecuente === 0) {
        series = listseries.frecuente.enum;
        data.series = listseries.frecuente.lista;
      } else if (controlsatisfaccion === 0) {
        series = listseries.satisfaccion.enum;
        data.series = listseries.satisfaccion.lista;
      } else if (controlburnout === 0) {
        series = listseries.burnout.enum;
        data.series = listseries.burnout.lista;
      } else if (controlcritico === 0) {
        series = listseries.critico.enum;
        data.series = listseries.critico.lista;
      } else if (controlprotector === 0) {
        series = listseries.protector.enum;
        data.series = listseries.protector.lista;
      } else if (controldefault1 === 0) {
        series = listseries.default1.enum;
        data.series = listseries.default1.lista;
      } else if (controlestres === 0) {
        series = listseries.estres.enum;
        data.series = listseries.estres.lista;
      }

      arraydata.forEach(function (k, v) {
        if (totales[k[0].Grupo] > 5) {
          k.forEach(function (k1, v1) {
            if (k1.SubGrupo) {
              data.data1[series[k1.SubGrupo]][v] += k1.countData.sum;
              data.data[series[k1.SubGrupo]][v] = Math.round(
                (data.data1[series[k1.SubGrupo]][v] / totales[k[0].Grupo]) * 100
              );
            }
          });
        }
      });
      this.datafactores = data;

      this.cambio1++;
    },
    selectTitulo(k) {
      this.buttonselected = k;
      this.organizaData(this.datafrs, k);
      if (k === "todos") {
        this.creaFactores("01");
      } else {
        this.creaFactores(k);
      }
    },
    clasebutton(k) {
      if (this.buttonselected === k) {
        return "is-link";
      }
    },
    cambio(data, prioridad, typeGraphic) {
      this.transformdata(data, prioridad, typeGraphic);
    },
    transformdata(data, prioridad, typeGraphic) {
      const dataGrafica = {
        prioridad,
        typeGraphic: "bar",
        options: {
          scales: {},
          legend: { position: "bottom", display: false },
          cutoutPercentage: 80,
        },
        datasetOverride: [],
        series: ["Priorización"],
        labels: ["1", "2", "3", "4", "5"],
        data: [[65.6, 57.1, 63.4, 58, 62.6]],
      };
      // const aleatorio = Math.round(Math.random());
      let aleatorio = Math.random() * 100;

      dataGrafica.options.cutoutPercentage = aleatorio;
      if (typeGraphic) {
        dataGrafica.typeGraphic = typeGraphic;
        data.typeGraphic = typeGraphic;
      } else {
        if (aleatorio > 66) {
          dataGrafica.typeGraphic = "polarArea";
          data.typeGraphic = "polarArea";
        } else if (aleatorio > 33) {
          dataGrafica.typeGraphic = "bar";
          data.typeGraphic = "bar";
        } else {
          dataGrafica.typeGraphic = "pie";
          data.typeGraphic = "pie";
        }
      }

      dataGrafica.labels = [];
      dataGrafica.data = [];
      const datos = [];
      for (let index = 0; index < 5; index++) {
        if (data.nombrerango[index + 1] !== "" && data[index + 1] !== 0) {
          dataGrafica.labels.push(data.nombrerango[index + 1]);
          datos.push(data[index + 1]);
        }
      }

      dataGrafica.data.push(datos);
      if (dataGrafica.typeGraphic === "bar") {
        dataGrafica.options = {
          scales: {
            yAxes: [
              {
                gridLines: {
                  display: true,
                  drawOnChartArea: false,
                },
                ticks: {
                  beginAtZero: true,
                },
              },
            ],
            xAxes: [
              {
                gridLines: {
                  display: true,
                },
              },
            ],
          },
          legend: { position: "bottom", display: false },
          // cutoutPercentage: 80,
        };
      }
      data.dataGrafica = dataGrafica;
      data.cambio++;
    },
    nombreriesgo(nombre) {
      const length = nombre.length;
      return nombre.substr(7, length);
    },
    clasificarango(dato, nombre) {
      const riesgomuyalto = ((dato[5]+ dato[4]) / dato.total) * 100;
      const aspectodestacado = ((dato[1] + dato[2]) / dato.total) * 100;
      const prioridadmedia = ((dato[5] + dato[4] + dato[3]) / dato.total) * 100;
      if (riesgomuyalto >= 25) {
        dato.clasif = "pa";
        dato.nclasif = dato[5];
        dato.porcentclasif = riesgomuyalto;
        this.datafrstrans.clasificados.pa.push({ nombre, n: dato.nclasif });
      } else if (prioridadmedia >= 40) {
        dato.clasif = "pm";
        dato.nclasif = dato[5] + dato[4] + dato[3];
        dato.porcentclasif = prioridadmedia;
        this.datafrstrans.clasificados.pm.push({ nombre, n: dato.nclasif });
      } else if (aspectodestacado > 60) {
        dato.clasif = "ad";
        dato.nclasif = dato[1] + dato[2];
        dato.porcentclasif = aspectodestacado;
        this.datafrstrans.clasificados.ad.push({ nombre, n: dato.nclasif });
      } else {
        dato.clasif = "na";
        dato.nclasif = dato.total;
        this.datafrstrans.clasificados.na.push({ nombre, n: dato.nclasif });
      }
    },
    organizaData(data, filtro) {
      try {
        const _this = this;
        const keysRiesgo = Object.keys(data.data);
        const keysresultados = [];
        this.datafrstrans = {
          listrgo: [],
          clasificados: {
            list: ["ad", "pm", "pa", "na"],
            ad: [],
            pm: [],
            pa: [],
            na: [],
          },
        };
        let rangofinal = 6;
        let textofiltro = `RGO-${filtro}`;
        if (filtro === "todos") {
          rangofinal = 3;
          textofiltro = "RGO";
        }
        for (let index = 0; index < keysRiesgo.length; index++) {
          if (keysRiesgo[index].substr(0, rangofinal) === textofiltro) {
            keysresultados.push(keysRiesgo[index]);
            _this.datafrstrans.listrgo.push(keysRiesgo[index]);
            _this.$set(_this.datafrstrans, keysRiesgo[index], {
              1: 0,
              2: 0,
              3: 0,
              4: 0,
              5: 0,
              total: 0,
              clasif: "",
              nclasif: 0,
              porcentclasif: 0,
              nombrerango: {
                1: "",
                2: "",
                3: "",
                4: "",
                5: "",
              },
              typeGraphic: "",
              cambio: 0,
              dataGrafica: {},
            });
            for (let index1 in data.data[keysRiesgo[index]]) {
              if (data.data[keysRiesgo[index]][index1].SubGrupo) {
                _this.datafrstrans[keysRiesgo[index]][
                  _this.definiciones[
                    data.data[keysRiesgo[index]][index1].SubGrupo
                  ]
                ] += data.data[keysRiesgo[index]][index1].countData.sum;
                _this.datafrstrans[keysRiesgo[index]].total +=
                  data.data[keysRiesgo[index]][index1].countData.sum;
                _this.datafrstrans[keysRiesgo[index]].nombrerango[
                  _this.definiciones[
                    data.data[keysRiesgo[index]][index1].SubGrupo
                  ]
                ] = data.data[keysRiesgo[index]][index1].SubGrupo;
              }
            }
          }
        }
        for (
          let index = 0;
          index < _this.datafrstrans.listrgo.length;
          index++
        ) {
          const dato = _this.datafrstrans[_this.datafrstrans.listrgo[index]];
          _this.clasificarango(dato, _this.datafrstrans.listrgo[index]);
        }
        for (let item of _this.datafrstrans.clasificados.list) {
          _this.datafrstrans.clasificados[item].sort(function (a, b) {
            return b.n - a.n;
          });
        }
        this.keysresultado = keysresultados;
        for (
          let index = 0;
          index < _this.datafrstrans.clasificados.pa.length;
          index++
        ) {
          _this.transformdata(
            _this.datafrstrans[
              _this.datafrstrans.clasificados.pa[index].nombre
            ],
            "pa"
          );
        }
        for (
          let index = 0;
          index < _this.datafrstrans.clasificados.ad.length;
          index++
        ) {
          _this.transformdata(
            _this.datafrstrans[
              _this.datafrstrans.clasificados.ad[index].nombre
            ],
            "ad"
          );
        }
        for (
          let index = 0;
          index < _this.datafrstrans.clasificados.pm.length;
          index++
        ) {
          _this.transformdata(
            _this.datafrstrans[
              _this.datafrstrans.clasificados.pm[index].nombre
            ],
            "pm"
          );
        }
      } catch (err) {
        console.log(err);
      }
    },
    traetitulo(k) {
      const length = this.riesgos[k].original.length;
      return this.riesgos[k].modificado[length - 1];
    },
    async traeData() {
      try {
        const _this = this;
        const result = await apiServices.get(
          `/informefrs/${this.$route.params.id}`
        );
        this.datafrs = result.data;
        // const dataFiltrada = [];
        for (let index = 0; index < this.datafrs.data.grupos.length; index++) {
          const dato = _this.datafrs.data.grupos[index];
          if (dato.substr(0, 4) === "RGO-") {
            if (_this.riesgos.numeros.indexOf(dato.substr(4, 2)) === -1) {
              _this.riesgos.numeros.push(dato.substr(4, 2));
              _this.riesgos[dato.substr(4, 2)] = {
                original: [],
                modificado: [],
              };
              _this.riesgos[dato.substr(4, 2)].original.push(dato);
              _this.riesgos[dato.substr(4, 2)].modificado.push(
                dato.substr(7, dato.length)
              );
            } else {
              _this.riesgos[dato.substr(4, 2)].original.push(dato);
              _this.riesgos[dato.substr(4, 2)].modificado.push(
                dato.substr(7, dato.length)
              );
            }
          }
        }
        _this.riesgos.numeros.sort();
        this.organizaData(this.datafrs, "01");
        this.creaFactores("01");
      } catch (err) {
        console.log(err);
      }
    },
  },
  created() {
    this.traeData();
  },
  components: {
    yMinigraph,
    yGraph,
  },
};
</script>
<style lang="scss" scoped>
.riesgoalto {
  background-color: #ce6757 !important;
  color: white;
}
.aspectodestacado {
  background-color: #15b7b9 !important;
  color: white;
}

.prioridadmedia {
  background-color: #ffd36e !important;
  color: #4a4a4a;
}
</style>


// WEBPACK FOOTER //
// src/components/frs/Priorizationfrs.vue